import { DefaultButton, DetailsList, DetailsListLayoutMode, SelectionMode, Stack, Text } from "@fluentui/react"
import TimeTaxSupportSystemClient from "../../system";
import { IComboBoxOption } from "office-ui-fabric-react";
import { useEffect, useState } from "react";
import { t } from "i18next";

interface IListWorkingDays {
  system: TimeTaxSupportSystemClient;
  selectedCompany: IComboBoxOption | undefined;
  date: any;
  onRegisterChange?: (isRegister: any) => void;
  isRegister: any;
  // date: any;
  // courier: MessageCourier;
  // user: User;
  // changeBlockUI: (state: boolean) => void;
  // config: SystemConfiguration;
  // periodsBlocked: PeriodDatesBlockedSystem;
}

export const ListWorkingDays = (props: IListWorkingDays) => {

  const [ListWorkingDays, setListWorkingDays] = useState<any[]>([]);
  const [totales, setTotales] = useState<any>();
  const [promedio, setPromedio] = useState<any>();

  const getListWorkingDay = async (company: string) => {
    const data = await props.system
      .getNonWorkingDaysSystem()
      .getListWorkingDaysHolidays(company, props.date);
    setListWorkingDays(data[0].data);
    setTotales(data[0].totales);
    setPromedio(data[0].promedio);
  };

  useEffect(() => {
    if (totales && promedio) {
      handleAddItem();
    }
  }, [promedio]);

  useEffect(() => {
    if (props.selectedCompany?.key && props.date) {
      getListWorkingDay(props.selectedCompany?.key.toString());
    }
  }, [props.selectedCompany, props.date, props.isRegister]);

  // Columnas para la tabla de días laborales
  const workdayColumns = [
    {
      key: "item",
      name: t("Item"),
      fieldName: "item",
      minWidth: 40,
      maxWidth: 40,
    },
    {
      key: "mes",
      name: t("Mes"),
      fieldName: "mes",
      minWidth: 110,
      maxWidth: 110,
    },
    {
      key: "diasLaborales",
      name: t("Días hábiles"),
      fieldName: "diasLaborales",
      minWidth: 100,
    },
    {
      key: "diasNoLaborales",
      name: t("Días feriados"),
      fieldName: "diasNoLaborales",
      minWidth: 100,
    },
    {
      key: "horasEstimadas",
      name: t("Hrs. estimadas"),
      fieldName: "horasEstimadas",
      minWidth: 100,
    },
    {
      key: "horasPracticantes",
      name: t("Hrs. Practicantes"),
      fieldName: "horasPracticantes",
      minWidth: 100,
      maxWidth: 150,
    },
  ];

  const handleAddItem = () => {
    const newItem = {
      item: null,
      mes: <span><b>{t('Totales')}</b><br /><br /><b>{t('Promedio Mensual')}</b></span>,
      diasLaborales: <span><b>{totales?.diasLaborales}</b><br /><br /><b>{promedio?.diasLaborales}</b></span>,
      diasNoLaborales: <span><b><br /><br /></b></span>,
      horasEstimadas: <span><b>{totales?.horasEstimadas}</b><br /><br /><b>{promedio?.horasEstimadas}</b></span>,
      horasPracticantes: <span><b>{totales?.horasPracticantes}</b><br /><br /><b>{promedio?.horasPracticantes}</b></span>,
    };
    setListWorkingDays((prevList) => [...prevList, newItem]);
  };

  return (
    <Stack
      tokens={{ childrenGap: 15 }}
      style={{
        backgroundColor: "white",
        width: "100%",
        padding: "20px",
        flex: 1,
      }}
    >
      <Text variant="xLarge">{t('Detalle días laborales')} {props.date}</Text>
      
      <DetailsList
        className="barraInferior"
        styles={{
          root: {   
            maxWidth: "fit-content"
          }
        }}
        items={ListWorkingDays}
        columns={workdayColumns}
        layoutMode={DetailsListLayoutMode.fixedColumns}
        selectionMode={SelectionMode.none}
        onRenderRow={(props, defaultRender) => {
          if (!props) return null;
          return defaultRender
            ? defaultRender({
                ...props,
                styles: {
                  root: {
                    backgroundColor:
                      props.itemIndex % 2 === 0 &&
                      props.itemIndex <= 11 ? "#F5F5F5" : "#FFFFFF",
                  },
                },
              })
            : null;
        }}
      />
    </Stack>
  );
};